/**
 * Formatting helpers local to the Admin Finance / P&L page (A7Y-2054).
 */

const MONTH_ABBR = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
] as const;

/**
 * 'YYYY-MM' → "Mon YYYY" (e.g. '2026-01' → "Jan 2026").
 * Falls back to the raw key if it doesn't parse, so bad data never throws.
 */
export function formatMonthLabel(month: string): string {
  const m = /^(\d{4})-(\d{2})$/.exec(month);
  if (!m) return month;
  const monthIndex = Number(m[2]) - 1;
  if (monthIndex < 0 || monthIndex > 11) return month;
  return `${MONTH_ABBR[monthIndex]} ${m[1]}`;
}

/** Short axis label: 'YYYY-MM' → "Mon" (drops the year for dense x-axes). */
export function formatMonthShort(month: string): string {
  const m = /^(\d{4})-(\d{2})$/.exec(month);
  if (!m) return month;
  const monthIndex = Number(m[2]) - 1;
  if (monthIndex < 0 || monthIndex > 11) return month;
  return MONTH_ABBR[monthIndex];
}
